import classNames from 'classnames'

import { useDateLocale, useTimeZone } from '../../../../hooks'
import { DragDropDroppableArea } from '../../../DragDrop'
import { CalendarGridDropType } from '../../CalendarGrid.constants'
import { getIsCalendarGridTodayTinted } from '../CalendarGridWeek.utils'
import { CalendarGridWeekCell } from '../CalendarGridWeekCell'

import {
  getCalendarGridDayBlocks,
  getCalendarGridTimeDropAreaId,
  getCalendarGridWeekGroupKey,
  getIsCalendarGridNowLineShown,
  getIsCalendarGridPreviewOnDay,
  getIsCalendarGridWeekLastHour,
} from './CalendarGridWeekColumn.utils'
import { CalendarGridWeekDropPreview } from './CalendarGridWeekDropPreview'
import { CalendarGridWeekGroup } from './CalendarGridWeekGroup'
import { CalendarGridWeekNowLine } from './CalendarGridWeekNowLine'

import * as styles from './CalendarGridWeekColumn.module.css'

function CalendarGridWeekColumn({
  canMoveItemsInTime,
  className = styles.CalendarGridWeekColumn,
  day,
  days,
  firstHour,
  hours,
  items,
  now,
  previewItem,
  today,
  onClickEmptyCell,
  onClickItem,
  onClickSecondaryLabel,
  onPointerDownCell,
  onPointerMoveCell,
}) {
  const locale = useDateLocale()
  const timezone = useTimeZone()

  return (
    <DragDropDroppableArea
      className={classNames(className, {
        [styles.today]: getIsCalendarGridTodayTinted({ day, days, today }),
      })}
      data={{
        day: day.date,
        firstHour,
        hourCount: hours.length,
        type: CalendarGridDropType.time,
      }}
      disabled={!canMoveItemsInTime}
      id={getCalendarGridTimeDropAreaId(day.date)}
    >
      {hours.map(hour => (
        <CalendarGridWeekCell
          day={day.date}
          hour={hour.value}
          isLast={getIsCalendarGridWeekLastHour({ hour, hours })}
          key={hour.value}
          now={now}
          onClick={onClickEmptyCell}
          onPointerDown={onPointerDownCell}
          onPointerMove={onPointerMoveCell}
        />
      ))}
      {getCalendarGridDayBlocks({ firstHour, items, locale, timezone }).map(
        group => (
          <CalendarGridWeekGroup
            canMoveItemsInTime={canMoveItemsInTime}
            day={day.date}
            group={group}
            key={getCalendarGridWeekGroupKey(group)}
            onClickItem={onClickItem}
            onClickSecondaryLabel={onClickSecondaryLabel}
          />
        )
      )}
      {getIsCalendarGridNowLineShown({
        day,
        firstHour,
        locale,
        now,
        timezone,
        today,
      }) ? (
        <CalendarGridWeekNowLine firstHour={firstHour} now={now} />
      ) : null}
      {getIsCalendarGridPreviewOnDay({ day, previewItem }) ? (
        <CalendarGridWeekDropPreview firstHour={firstHour} item={previewItem} />
      ) : null}
    </DragDropDroppableArea>
  )
}

export default CalendarGridWeekColumn
